<template>
  <JoinWrapper>
    <div class="box">
      <!-- PROGRESS BAR -->
      <JoinProgress :stage="stage" />
      <!-- / PROGRESS BAR -->

      <div class="mobile_device">
        <div v-if="getRegisterMemberType === '1000'" class="topic">
          학교/학과 정보 <span class="choice_style">(선택)</span>
        </div>
        <div v-if="getRegisterMemberType === '2000'" class="topic">
          회원정보 <span class="essential_style">필수</span>
        </div>
        <div class="unicol_wrap">
          <span class="id_txt txt_style">학교</span>
          <label for="unicol">
            <input
              id="unicol"
              v-model="groups.unicolNm"
              class="input_t"
              :class="{ 'put-chk': colHasInput }"
              name="unicol"
              placeholder="학교를 선택해 주세요"
              readonly="readonly"
              @click="toggleUnicolModal"
            />
            <button class="search" @click="toggleUnicolModal">
              검색
            </button>
          </label>
        </div>
        <div class="division_wrap">
          <span class="password_txt txt_style">학부(학과)</span>
          <label for="division">
            <input
              id="division"
              v-model="groups.division"
              class="input_t"
              name="division"
              placeholder="학부(학과)를 선택해 주세요"
              readonly="readonly"
              :disabled="!groups.unicolNm"
              @click="toggleDepartModal"
            />
            <button
              class="search"
              :class="{ dull: !groups.unicolNm }"
              :disabled="!groups.unicolNm"
              @click="toggleDepartModal"
            >
              검색
            </button>
          </label>
        </div>
        <div v-if="getRegisterMemberType === '2000'" class="classNm_wrap">
          <span class="classNm_txt txt_style">강의명</span>
          <label for="classNm">
            <input
              id="classNm"
              v-model="groups.classNm"
              class="input_t"
              :class="{ 'put-chk': classNmHasInput }"
              name="classNm"
              maxlength="20"
              placeholder="강의명을 입력해 주세요"
            />
          </label>
        </div>
        <div v-if="getRegisterMemberType === '2000'" class="publish_wrap">
          <span class="publish_txt txt_style">출판사</span>
          <label for="publish">
            <input
              id="publish"
              v-model="publisherString"
              name="publish"
              class="input_t"
              :class="{ 'put-chk': pubHasInput }"
              placeholder="출판사를 선택해 주세요"
              readonly="readonly"
              @click="togglePublishModal"
            />
            <button class="search" @click="togglePublishModal">
              검색
            </button>
          </label>
          <p class="info_source">
            선택한 출판사에 내 정보를 제공합니다. (증정본 제공 시 활용)
          </p>
        </div>
      </div>
      <p v-if="getRegisterMemberType === '1000'" class="nonePut_ok">
        학생이 아니라면 입력하지 않아도 괜찮아요.
      </p>
      <div v-if="getRegisterMemberType === '1000'" class="btn_wrap">
        <button class="box_btn next_btn" @click="registerUser">
          다음
        </button>
      </div>
      <div v-if="getRegisterMemberType === '2000'" class="btn_wrap">
        <button
          class="box_btn next_btn"
          :class="{ dull: !isValid }"
          :disabled="!isValid"
          @click="registerUser"
        >
          다음
        </button>
      </div>
      <unicolModal
        v-if="isShowUnicol"
        @close="toggleUnicolModal"
        @unicolInfo="selectUnicol"
      />
      <departmentModal
        v-if="isShowDepart"
        :groups-unicol-nm="groups.unicolNm"
        :groups-unicol-cd="groups.unicolCd"
        @close="toggleDepartModal"
        @departInfo="selectDepart"
      />
      <publishModal
        v-if="isShowPubl"
        @close="togglePublishModal"
        @pbList="selectPublishList"
      />
    </div>
  </JoinWrapper>
</template>

<script>
import JoinWrapper from '@/components/auth/JoinWrapper.vue'
import JoinProgress from '@/components/auth/JoinProgress.vue'
import unicolModal from '@/components/library/unicolModal.vue'
import departmentModal from '@/components/library/departmentModal.vue'
import publishModal from '@/components/library/publishModal.vue'
import { mapGetters } from 'vuex'
import { AUTH_REGISTER, AUTH_REGISTER_SOCIAL } from '@/store/types'
export default {
  name: 'JoinStep4',
  components: {
    JoinProgress,
    JoinWrapper,
    unicolModal,
    publishModal,
    departmentModal
  },
  data() {
    return {
      stage: 4,
      name: '',
      publishList: '',
      publisherNm: [],
      publisherCd: [],
      publisherString: '',
      isShowUnicol: false,
      isShowDepart: false,
      isShowPubl: false,
      showErrorModal: false,
      errorMessage: '',
      groups: {
        publisherGroup: [],
        unicolCd: '',
        division: '',
        selectedDepartments: [], // deptName, deptSeqs의 배열
        unicolNm: '',
        classNm: ''
      },
      isKorean: false,
      emailChecked: false,
      colHasInput: false,
      colSubHasInput: false,
      classNmHasInput: false,
      pubHasInput: false,
      type: this.$route.query.type,
      id: this.$route.query.id,
      email: this.$route.params.contactMethods.email.selected,
      messages: this.$route.params.contactMethods.messages.selected
    }
  },
  computed: {
    ...mapGetters([
      'getCurrentUser',
      'isAuthLoading',
      'getRegisterMemberType',
      'getMainCategories',
      'getDepartmentsList'
    ]),
    isValid() {
      const commonConditions =
        this.groups.unicolNm &&
        this.groups.division &&
        this.groups.classNm &&
        this.publisherString
      if (commonConditions) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    unicolNm(put) {
      this.colHasInput = put && put.length > 0
    },
    'groups.division'(put) {
      this.colSubHasInput = put && put.length > 0
    },
    'groups.classNm'(put) {
      this.classNmHasInput = put && put.length > 0
    },
    publisherString(put) {
      this.pubHasInput = put && put.length > 0
    }
  },
  beforeDestroy() {
    this.$store.dispatch('setCookie', {
      name: 'ealice_mail2',
      value: '',
      exp: 0
    })
  },
  beforeMount() {
    if (!this.$route.params?.data && this.type !== 'c') {
      this.$router.push({ name: 'sign_up' })
    }

    this.verifiedInfo = this.$route.params.verifiedInfo || {}
    this.name = this.verifiedInfo.name || ''

    if (this.verifiedInfo.type === 'phone') {
      this.isKorean = true
    }
    if (this.verifiedInfo.type === 'email') {
      this.username = this.verifiedInfo.email
      return
    }
  },
  methods: {
    isTeacherInfoValid() {
      return (
        this.groups.division &&
        this.groups.classNm &&
        this.groups.unicolCd &&
        this.publishList.length > 0
      )
    },
    selectUnicol(school) {
      if (!school) {
        this.toggleUnicolModal()
        return
      }
      this.toggleUnicolModal()
      this.groups.unicolNm = school.unicolNm
      this.groups.unicolCd = school.unicolCd
      this.groups.division = '' // 학교 재선택시 학과 초기화
      this.groups.selectedDepartments = []
    },
    selectDepart(diviForm) {
      if (!diviForm) {
        this.toggleDepartModal()
        return
      }
      this.toggleDepartModal()

      this.groups.selectedDepartments = diviForm

      // departInfo가 배열일 경우
      if (Array.isArray(diviForm)) {
        // departInfo의 모든 deptName을 groups.division에 설정

        this.groups.division = diviForm.map((dept) => dept.deptName)
      }
      // departInfo가 단일 객체일 경우
      else {
        this.groups.division = [diviForm.deptName]
      }
    },
    selectPublishList(publishList) {
      if (!publishList) {
        this.togglePublishModal()
        return
      }
      this.togglePublishModal()
      this.publishList = publishList
      // 선택된 출판사 정보 중 이름만 모음
      this.publisherNm = []
      this.publishList.forEach((e) => {
        this.publisherNm.push(e.publisherNm)
      })
      // 출력용. 3개 이후 생략
      this.publisherString = ''
      if (this.publisherNm.length > 3) {
        this.publisherString =
          this.publisherNm[0] +
          ', ' +
          this.publisherNm[1] +
          ', ' +
          this.publisherNm[2] +
          ' 외 ' +
          (this.publisherNm.length - 3) +
          '개'
      } else {
        this.publisherNm.forEach((e, index) => {
          if (index !== 0) {
            this.publisherString += ', '
          }
          this.publisherString += e
        })
      }
    },
    formatRegisterData() {
      let data = {}

      if (this.getRegisterMemberType === '1000') {
        data.groups = {}
        data.groups.unicolCd = this.groups.unicolCd
        data.groups.unicolNm = this.groups.unicolNm
        // data.groups.division = this.groups.division
        data.groups.departmentList = this.groups.selectedDepartments
      }
      if (this.getRegisterMemberType === '2000') {
        data.groups = {}
        data.groups.publisherGroup = this.publishList.map((e) => {
          return e.publisherCd
        })
        data.groups.unicolCd = this.groups.unicolCd
        data.groups.unicolNm = this.groups.unicolNm
        // data.groups.division = this.groups.division
        data.groups.departmentList = this.groups.selectedDepartments
        data.groups.classNm = this.groups.classNm
      }
      data.terms = { termsOfUse: true, collectAndUse: true }
      data.agreements = {
        email: this.email,
        messages: this.messages
      }
      data.memberTp = this.getRegisterMemberType
      data.name = this.$route.params?.data.name
      data.birthDate = this.$route.params?.data.birthday
      data.loginId = this.$route.params?.data.loginId
      data.loginPwd = this.$route.params?.data.loginPwd
      data.mobileNo = this.$route.params?.data.mobileNo
      // data.registerTp = this.$route.params?.data.loginId ? 'EM' : 'MO'
      data.gender = this.$route.params?.data.gender
      data = {
        ...data,
        impUid: this.$route.params?.data.impUid,
        merchantUid: this.$route.params?.data.merchantUid
      }
      return data
    },
    async registerUser() {
      this.errorMessage = ''
      if (this.getRegisterMemberType === '2000') {
        if (!this.isTeacherInfoValid()) {
          alert('학교, 학과, 강의명, 출판사를 입력해주세요.')
          return
        }
      }
      const data = this.formatRegisterData()
      try {
        if (this.type === 'NEW_USER') {
          await this.$store.dispatch(AUTH_REGISTER_SOCIAL, {
            data: data,
            sessionId: this.id
          })
        } else {
          await this.$store.dispatch(AUTH_REGISTER, { data })
        }
        this.$router.push({ name: 'join_complete', params: { data } })
      } catch (err) {
        this.toggleErrorModal()
      }
    },
    toggleUnicolModal() {
      this.isShowUnicol = !this.isShowUnicol
    },
    toggleDepartModal() {
      this.isShowDepart = !this.isShowDepart
    },
    togglePublishModal() {
      this.isShowPubl = !this.isShowPubl
    },
    closeErrorModal() {
      this.showErrorModal = false
      this.erorrMessage = ''
    },
    toggleErrorModal() {
      this.showErrorModal = !this.showErrorModal
    }
  }
}
</script>

<style lang="scss" scoped>
.input_t {
  &:focus {
    border: 1px solid #008df3;
  }
}
.unicol_wrap,
.division_wrap,
.classNm_wrap {
  margin-bottom: 24px;
}
label[for='unicol'],
label[for='publish'],
label[for='division'] {
  position: relative;
}
.search {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  padding: 8px 16px;
  font-family: 'pretendard-medium';
  font-size: 16px;
  letter-spacing: 0;
  border-radius: 8px;
  background-color: #008df3;
  color: #ffffff;
  &.dull {
    opacity: 0.5;
  }
}
.info_source {
  margin: 7px 0 130px;
  font-size: 16px;
  letter-spacing: 0;
  color: #999999;
}
.nonePut_ok {
  margin: 300px 0 20px;
  text-align: center;
  letter-spacing: 0;
  font-size: 15px;
  color: #0074c8;
}
.choice_style {
  font-size: 16px;
  color: #999999;
}
.essential_style {
  font-family: 'pretendard-medium';
  font-size: 16px;
  color: #0074c8;
}
@media (max-height: 667px) {
  .nonePut_ok {
    margin: 220px 0 20px;
  }
}
</style>
